import { render, staticRenderFns } from "./WarehouseOutputFactorProducts.vue?vue&type=template&id=497e785c&"
import script from "./WarehouseOutputFactorProducts.vue?vue&type=script&lang=js&"
export * from "./WarehouseOutputFactorProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports